//google-analyze.js
export default {
    GA_TRACKING_ID: 'UA-177277299-1',
    event(eventCategory, eventAction, eventLabel, eventValue) {
        if (window.gtag) {
            window.gtag('event', eventAction, {//一个具体的操作
                event_category: eventCategory,//一个大类
                event_label: eventLabel,//额外的一些信息
                value: eventValue,//为正的整数
                send_to: this.GA_TRACKING_ID
            })
        }
    },
    page(page, title, location) {
        if (window.gtag) {
            window.gtag('config', this.GA_TRACKING_ID, {
                page_title: title,
                page_path: page,
                page_location: location
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/google-analyze.js